import $ from 'jquery';

export default function searchToggle() {
    const
        $form = $('#banner form[role="search"]'),
        $keywords = $('#keywords');

    $keywords
        .on('focus', function() {
            $form.addClass('is-focused');
        })
        .on('blur', function() {
            $form.removeClass('is-focused');
        })
        .on('input', function() {
            if ($(this).val() !== '') {
                $form.addClass('has-value');
            } else {
                $form.removeClass('has-value');
            }
        });
}
